/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Venue_UnassignedInputs */

const th_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่กำหนด`)
};

const en_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not assigned`)
};

const ja_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未割り当て`)
};

const zh_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未分配`)
};

const es_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin asignar`)
};

const pt_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não definido`)
};

const id_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ditetapkan`)
};

const fr_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non attribuée`)
};

const tl_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi naitalaga`)
};

const vi_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa phân`)
};

const ko_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`미배정`)
};

const de_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht zugewiesen`)
};

const ru_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не назначена`)
};

const tr_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atanmadı`)
};

const it_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non assegnato`)
};

const pl_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieprzypisana`)
};

const uk_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не призначено`)
};

const hi_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तय नहीं`)
};

const ar_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير معيَّنة`)
};

const ms_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ditetapkan`)
};

const bn_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নির্ধারিত নয়`)
};

const zh_tw2_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未指派`)
};

const zh_hk2_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未指派`)
};

const ur_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقرر نہیں`)
};

const fa_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعیین‌نشده`)
};

const sw_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haujapangwa`)
};

const nl_venue_unassigned = /** @type {(inputs: Venue_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet toegewezen`)
};

/**
* | output |
* | --- |
* | "Not assigned" |
*
* @param {Venue_UnassignedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const venue_unassigned = /** @type {((inputs?: Venue_UnassignedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Venue_UnassignedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_venue_unassigned(inputs)
	if (locale === "ja") return ja_venue_unassigned(inputs)
	if (locale === "zh") return zh_venue_unassigned(inputs)
	if (locale === "es") return es_venue_unassigned(inputs)
	if (locale === "pt") return pt_venue_unassigned(inputs)
	if (locale === "id") return id_venue_unassigned(inputs)
	if (locale === "fr") return fr_venue_unassigned(inputs)
	if (locale === "tl") return tl_venue_unassigned(inputs)
	if (locale === "vi") return vi_venue_unassigned(inputs)
	if (locale === "ko") return ko_venue_unassigned(inputs)
	if (locale === "de") return de_venue_unassigned(inputs)
	if (locale === "ru") return ru_venue_unassigned(inputs)
	if (locale === "tr") return tr_venue_unassigned(inputs)
	if (locale === "it") return it_venue_unassigned(inputs)
	if (locale === "pl") return pl_venue_unassigned(inputs)
	if (locale === "uk") return uk_venue_unassigned(inputs)
	if (locale === "hi") return hi_venue_unassigned(inputs)
	if (locale === "ar") return ar_venue_unassigned(inputs)
	if (locale === "ms") return ms_venue_unassigned(inputs)
	if (locale === "bn") return bn_venue_unassigned(inputs)
	if (locale === "zh-TW") return zh_tw2_venue_unassigned(inputs)
	if (locale === "zh-HK") return zh_hk2_venue_unassigned(inputs)
	if (locale === "ur") return ur_venue_unassigned(inputs)
	if (locale === "fa") return fa_venue_unassigned(inputs)
	if (locale === "sw") return sw_venue_unassigned(inputs)
	if (locale === "nl") return nl_venue_unassigned(inputs)
	return en_venue_unassigned(inputs)
});